import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { ICandidate } from "../../../App/Typings/Candidate";

interface IRemoveCandidateDialogProps {
  confirmRemoveDialogOpen: boolean;
  handleCloseConfirmRemoveDialog: () => void;
  handleRemoveCandidateFromGroup: () => void;
  candidateToRemove: ICandidate;
  groupName: string;
}

export function RemoveCandidateDialog({
  confirmRemoveDialogOpen,
  handleCloseConfirmRemoveDialog,
  handleRemoveCandidateFromGroup,
  candidateToRemove,
  groupName,
}: IRemoveCandidateDialogProps) {
  return (
    <Dialog
      id="removecandidate-dialog"
      open={confirmRemoveDialogOpen}
      onClose={handleCloseConfirmRemoveDialog}
      scroll="paper"
      aria-labelledby="removecandidate-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="removecandidate-title"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1,
        }}
      >
        Remove Candidate from {groupName}
      </DialogTitle>
      <DialogContent dividers={true}>
        <Typography id="removecandidate-description">
          {`Are you sure you want to remove ${candidateToRemove.firstName} ${candidateToRemove.lastName} from ${groupName}?`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ py: 2, px: 3 }}>
        <Button data-test={`cancel-remove-${candidateToRemove.id}`} onClick={handleCloseConfirmRemoveDialog}>
          Cancel
        </Button>
        <Button data-test={`confirm-remove-${candidateToRemove.id}`} onClick={handleRemoveCandidateFromGroup}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
